import { render, staticRenderFns } from "./InEnglishModal.vue?vue&type=template&id=132d9efa&"
import script from "./InEnglishModal.vue?vue&type=script&lang=js&"
export * from "./InEnglishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InEnglishModal.vue"
export default component.exports